import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import * as moment from 'moment'
import {Watchdog} from "../model/watchdog";
import {select, Store} from "@ngrx/store";
import {currentUser} from "src/app/modules/users/store/user.selectors";
import {take} from "rxjs/operators";
import {environment} from "@env/environment";
import {ErrorService} from "./error.service";

@Injectable({
  providedIn: 'root'
})
export class WatchdogService {

  constructor(
    private http: HttpClient,
    private store: Store,
    private errorService: ErrorService
  ) { }

  writeWatchdog(wathdog: Partial<Watchdog>) {
    this.store.pipe(
      select(currentUser),
      take(1)
    ).subscribe(res => {
      if(res){
        const request = { ...wathdog, user: res.email || 'anonimo', datetime: moment().toISOString() }
        this.http.post(`${environment.DASHBOARD_PUBLIC_BASE_URL}/aggiungiLog`, request).subscribe()
      }
    })
  }
}
